module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("\n    Copyright © " + _vm._s(_vm.data.year) + " Medellín - Colombia Gerencia de Ingeniería y Desarrollo Emtelco S.A.S\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb86f34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-footer.vue
// module id = 80
// module chunks = 0